export { default } from './BundleConsoleHttpBase';
